import { type CollabLayoutType } from '@databases/model/views/view';

import { type SystemTemplateType } from './types';

export type TemplateStorageData = {
  templateType?: SystemTemplateType;
  templateLayout?: CollabLayoutType;
};

export type StorageType = {
  exists: () => boolean;
  getTemplateData: () => TemplateStorageData | undefined;
  remove: () => void;
};

const LS_TEMPLATE_KEY = 'databases-create-with-template-type';

export const storage: StorageType = {
  exists: () => {
    return Boolean(localStorage.getItem(LS_TEMPLATE_KEY));
  },
  getTemplateData: () => {
    const item = localStorage.getItem(LS_TEMPLATE_KEY);
    if (!item) {
      return undefined;
    }
    try {
      return JSON.parse(item) as TemplateStorageData;
    } catch {
      return undefined;
    }
  },
  remove: () => {
    localStorage.removeItem(LS_TEMPLATE_KEY);
  },
};
